// Changes to these properties of elements do not create a new history entry
// if only one (or multiple) of these properties change but nothing else changes.
// These are still saved as part of changes involving other properties.
export const PAGE_PROPS_TO_IGNORE = ['cssAnimations'];
export const SAVED_COLOR_PROPS_TO_IGNORE = ['isLocal', 'error'];
export const ELEMENT_PROPS_TO_IGNORE = [
  'resource.baseColor',
  'resource.blurHash',
  'resource.id',
  'resource.noAudio',
  'resource.posterId',
  'resource.poster',
  'resource.font.metrics',
  'resource.font.weights',
  'resource.font.variants',
  'resource.font.fallbacks',
  'resource.font.styles',
  'resource.isOptimized',
  'resource.length',
  'resource.lengthFormatted',
  'resource.trimData.original',
  'resource.trimData.start',
  'resource.trimData.end',
  'resource.creationDate',
  'resource.loading',
  'resource.pendingPlacementId',
  'resource.src',
  'resource.sizes',
];
